// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.query-metadata-header {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 1.5rem;
  overflow: hidden;
}

.header-title {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.25rem;
  background: var(--button-color);
  color: white;
  cursor: pointer;
}

.header-title h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
}

.header-summary {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-left: auto;
}

.tipo-badge {
  background: rgba(255,255,255,0.2);
  padding: 0.25rem 0.6rem;
  border-radius: 4px;
  font-size: 0.85rem;
  text-transform: capitalize;
}

.ops-count {
  font-size: 0.85rem;
  opacity: 0.9;
}

.filename {
  font-size: 0.8rem;
  opacity: 0.8;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.expand-icon {
  font-size: 0.7rem;
  opacity: 0.8;
  margin-left: 0.5rem;
}

.operations-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 1rem 1.25rem;
  background: #f8f9fa;
}

.op-tag {
  background: var(--button-color);
  color: white;
  padding: 0.3rem 0.6rem;
  border-radius: 4px;
  font-size: 0.8rem;
}

@media (max-width: 600px) {
  .header-summary {
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .filename {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Search/QueryMetadataHeader.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,+BAA+B;EAC/B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".query-metadata-header {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  margin-bottom: 1.5rem;\n  overflow: hidden;\n}\n\n.header-title {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem 1.25rem;\n  background: var(--button-color);\n  color: white;\n  cursor: pointer;\n}\n\n.header-title h3 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.header-summary {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-left: auto;\n}\n\n.tipo-badge {\n  background: rgba(255,255,255,0.2);\n  padding: 0.25rem 0.6rem;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  text-transform: capitalize;\n}\n\n.ops-count {\n  font-size: 0.85rem;\n  opacity: 0.9;\n}\n\n.filename {\n  font-size: 0.8rem;\n  opacity: 0.8;\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.expand-icon {\n  font-size: 0.7rem;\n  opacity: 0.8;\n  margin-left: 0.5rem;\n}\n\n.operations-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  padding: 1rem 1.25rem;\n  background: #f8f9fa;\n}\n\n.op-tag {\n  background: var(--button-color);\n  color: white;\n  padding: 0.3rem 0.6rem;\n  border-radius: 4px;\n  font-size: 0.8rem;\n}\n\n@media (max-width: 600px) {\n  .header-summary {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  .filename {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
